import { createFileRoute } from '@tanstack/react-router';
import { HistoryTab, validateHistorySearch } from '@/features/shipment-detail/history/history-tab';

// S07 · History (07 §3). Filter in the URL: ?kind=state|alert|notification|person|dokless|delivery
export const Route = createFileRoute('/_app/shipments/$id/history')({
  validateSearch: validateHistorySearch,
  component: HistoryTab,
});
